const GENDER = {
    MALE: 1,
    FEMALE: 2
};

export const toGenderString = (g) => g === GENDER.FEMALE ? 'female' : 'male';


export default GENDER;
